/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-08-12 10:42:52
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-22 10:05:49
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Col, message, notification, Table, Tooltip } from 'antd'
import moment from 'moment'
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { Columns, TransactionDetailAGColumns } from './columns'
import styles from '../transactionQueryTab.module.css'
import { Query } from './Query'
import { ThemeContext } from '../../../theme/ThemeContext'
import { getDateRange, DateRangeType } from '../../../compnents/form/DateSelect'
import {
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnlyOne,
} from '../../../models/datetime'
import {
  getPageColumnListAsync,
  getSubmitPageColumnListAsync,
  getTransactionDetailQueryExport,
  getTransactionDetailQueryList,
  getTransactionDetailQueryTotal,
  setExportLoading,
  setExportTag,
} from '../transactionQuerySlice'
import { sum } from 'lodash'
import { selectEdition, selectInsuranceArray } from '../../../app/applicationSlice'
import {
  getRecipeItemCompletions,
  ItemCompletionType,
} from '../../completion/completionSlice'
import SimpleAgGrid from '../../../compnents/simpleTable/SimpleAgGrid'
import { getSortColumnList } from '../../../models/common'
const exportXLSXList: any[] = []

interface TransactionDetailQueryProps {
  selectedTab?: any
  flag?: any
  CKHZSJHData?: boolean
  CKHZSFZHData?: boolean
  fromHome?: boolean 
}

export interface TransactionDetailQueryRef {
  reload: () => void
}

const TransactionDetailQuery = (
  { selectedTab, flag, CKHZSJHData, CKHZSFZHData }: TransactionDetailQueryProps,
  ref: React.Ref<TransactionDetailQueryRef>
): ReactElement => {
  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const [timeHead, timeTail] = getDateRange(DateRangeType.Today)

  const [scrollHeight, setScrollHeight] = useState<any>()

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
    registrationTimeHead: moment(timeHead).format(DateTimeFormatSimpleOnlyOne),
    registrationTimeTail: moment(timeTail).format(DateTimeFormatSimpleOnlyOne),
  })

  const [ids, setIds] = useState<number[]>([])

  const [page, setPage] = useState<any>()

  const [allTotalData, setAllTotalData] = useState<any>()

  const [allPage, setAllPage] = useState<any>()

  const [totalData, setTotalData] = useState<any>()

  const [pageLoading, setPageLoading] = useState(false)

  const [releasingTimeFlag, setReleasingTime] = useState(false)

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const insuranceArray = useSelector(selectInsuranceArray)

  // 所有的列表
  const listData: any = [
    {
      headerName: '序号',
      width: 80,
      minWidth: 80,
      field: 'index',
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '结算编号',
      field: 'paymentId',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '门诊号',
      field: 'outpatientNo',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '患者姓名',
      field: 'patientName',
      minWidth: 130,
      filter: false,
      visible: true,
    },
    {
      headerName: '病历号',
      field: 'patientId',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '身份证号',
      field: 'idCardNumber',
      minWidth: 175,
      visible: true,
    },
    {
      headerName: '手机号',
      field: 'patientPhone',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '患者来源',
      field: 'patientSource',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '诊断疾病',
      field: 'disease',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '接诊医生',
      field: 'treatmentDoctorName',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '收费时间',
      field: 'chargeOrRefundTime',
      minWidth: 175,
      visible: true,
    },
    {
      headerName: '结算险种',
      field: 'insuranceCode',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '人员险种',
      field: 'xianzhonglx',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '开票项目',
      field: 'billingCategory',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '项目名称',
      field: 'drugName',
      align: 'center',
      minWidth: 150,
      visible: true,
    },
    {
      headerName: '医保编码',
      field: 'hilistCode',
      minWidth: 200,
      visible: false,
    },
    {
      headerName: '甲乙分类',
      field: 'chrgitmLv',
      minWidth: 120,
      visible: false,
    },
    {
      headerName: '牙位',
      field: 'toothStruct',
      minWidth: 140,
      visible: true,
    },
    {
      headerName: '单价',
      field: 'retailPrice',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '数量',
      field: 'drugCount',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '金额',
      field: 'drugAmount',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '支付方式',
      field: 'payMethodName',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '结算状态',
      field: 'state',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '用法',
      field: 'normalUsemethod',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '批号',
      field: 'batchNo',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '有效期',
      field: 'deadline',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '供应商',
      field: 'gysName',
      minWidth: 170,
      visible: true,
    },
    {
      headerName: '医保结算编号',
      field: 'yibaojsbh',
      minWidth: 280,
      visible: true,
    },
    {
      headerName: '结算就诊编号',
      field: 'yibaojzbh',
      minWidth: 280,
      visible: true,
    },
    {
      headerName: '医保人员编号',
      field: 'yibaorybh',
      minWidth: 280,
      visible: true,
    },
    {
      headerName: '费用明细流水号',
      field: 'fymxid',
      minWidth: 170,
      visible: true,
    },
  ]?.map((v, index) => {
    return {
      ...v,
      index: index + 1,
    }
  })

  const allColumnData = listData

  const selectColumns = allColumnData?.filter((v: any) => v.visible)?.map((item: any) => item.field) || []

  const [columnQueryFilterList, setColumnQueryFilterList] = useState<any[]>([])

  const [allColumnList, setAllColumnList] = useState<any[]>([]) //筛选列所有的数据

  // 筛选列所有的数据
  const [filterColumnList, setFilterColumnList] = useState<any[]>([])

  const [filterSelectList, setFilterSelectList] = useState<any[]>([]) //筛选列所有的数据

  useEffect(() => {
    setReleasingTime(false)
  }, [])

  const submitPageList = (data: any) => {
    const params = {
      pageName: 'transactionQueryDetail',
      configJson: JSON.stringify(data),
    }
    dispatch(getSubmitPageColumnListAsync({
      ...params,
    }))
      .then(unwrapResult)
      .then((v: any) => {
        getPageColumnList(v?.id)
      })
  }

  const getPageColumnList = (id?: any) => {
    dispatch(getPageColumnListAsync({
      id: id ? id : undefined,
      pageName: 'transactionQueryDetail',
    }))
      .then(unwrapResult)
      .then((v: any) => {
        const data: any = v?.configJson ? JSON.parse(v?.configJson) : []
        const filterList = data?.filter((n: any) => n?.visible)
        const columns = filterList?.map((n: any) => n?.field)
        const resetData = data?.map(((v: any) => {
          const sameFileds = allColumnData?.find((item: any) => item?.field == v?.field)
          return {
            ...v,
            minWidth: sameFileds?.minWidth || v?.minWidth,
            width: sameFileds?.width || v?.width,
            headerName: sameFileds?.headerName || v?.headerName,
          }
        }))
        // 所有的数据
        setAllColumnList(data?.length ? resetData : allColumnData)
        // 筛选后存在后端的数据

        setFilterColumnList(filterList?.length ? filterList : allColumnData)
        // 选中的值
        setFilterSelectList(columns?.length ? columns : selectColumns)
      })
      .catch(() => {
        setAllColumnList(allColumnData)
        setFilterColumnList(allColumnData)
        setFilterSelectList(selectColumns)
      })
      .finally(() => {
        setPageLoading(false)
      })
  }

  useEffect(() => {
    if (allColumnList?.length) {
      // 医保才展示甲乙分类 、医保编码
      const insuranceListData = insuranceArray.length ? allColumnList : allColumnList?.filter((v: any) => v.field != 'chrgitmLv' && v.field != 'hilistCode')
      const columnData = hisVersion == 1 ? insuranceListData : (
        insuranceListData?.filter((v: any) => v.field != 'toothStruct')
      )
      setColumnQueryFilterList(columnData)
    }
  }, [allColumnList])

  useEffect(() => {
    if (selectedTab == '1') {
      setAllColumnList(allColumnData)
    }
  }, [selectedTab])

  useEffect(() => {
    if (selectedTab == '2') {
      setPageLoading(true)
      getPage()
      getPageColumnList()
      // dispatch(
      //   getTransactionDetailQueryList({
      //     ...params,
      //     size: -1,
      //     selectedTab: undefined,
      //   })
      // )
      //   .then(unwrapResult)
      //   .then((v: any) => {
      //     setAllPage(v?.records)
      //   })
    }
  }, [selectedTab, params])

  const getPage = () => {
    dispatch(getTransactionDetailQueryList(params))
      .then(unwrapResult)
      .then((v: any) => {
        onResize() // 初始化设置高度
        window.addEventListener('resize', onResize)
        setPage({
          items: v?.records,
          size: v?.size,
          total: v?.total,
          current: v?.current,
        })
        dispatch(getTransactionDetailQueryTotal(params))
          .then(unwrapResult)
          .then((v: any) => {
            setAllTotalData(v)
            setPageLoading(false)
          })
          .catch(() => {
            setPageLoading(false)
          })
      })
      .catch(() => {
        setPageLoading(false)
      })
  }

  // 计算合计数据
  useEffect(() => {
    // if (ids?.length) {
    //   if (allPage?.length) {
    //     // 过滤出的包含勾选的所有数据
    //     const filterList: any = []
    //     ids.forEach((item: any) => {
    //       allPage.forEach((element: any) => {
    //         if (item == element.paymenItemtId) {
    //           filterList.push(element)
    //         }
    //       })
    //     })
    //     // 计算合计
    //     const drugAmountAll = sum(
    //       filterList?.map((v: any) =>
    //         v?.drugAmount > -1 ? Number(v?.drugAmount) : 0
    //       )
    //     )
    //     setTotalData({
    //       drugAmountAll: drugAmountAll,
    //     })
    //   }
    // } else {
    const list = page?.items?.filter((v: any) => v?.state != 5)
    const data = !params?.state ? list : page?.items
    if (data?.length) {
      // 没勾选的情况下计算全部
      const drugAmountAll = sum(
        data?.map((v: any) => (v?.drugAmount > -1 ? Number(v?.drugAmount) : 0))
      )
      const drugCountAll = sum(
        data?.map((v: any) => (v?.drugCount > -1 ? Number(v?.drugCount) : 0))
      )
      setTotalData({
        drugAmountAll: drugAmountAll,
        drugCountAll: drugCountAll,
      })
    } else {
      setTotalData({
        drugAmountAll: 0,
        drugCountAll: 0,
      })
    }
    // }
  }, [page])

  useEffect(() => {
    dispatch(setExportTag(ids?.length ? true : false))
  }, [ids])

  useImperativeHandle(ref, () => ({
    reload: () => {
      outCluedExport()
    },
  }))

  const outCluedExport = () => {
    dispatch(setExportLoading(true))
    // const theader = [
    //   '结算编号',
    //   '患者姓名',
    //   '病历号',
    //   '手机号',
    //   '结算险种',
    //   '开票项目',
    //   '药品名称',
    //   '单价',
    //   '数量',
    //   '金额',
    //   '接诊医生',
    //   '收费时间',
    //   '结算状态',
    // ]

    // const filterVal = [
    //   'paymentId',
    //   'patientName',
    //   'patientId',
    //   'patientPhone',
    //   'insuranceCode',
    //   'billingCategory',
    //   'drugName',
    //   'retailPrice',
    //   'drugCount',
    //   'drugAmount',
    //   'treatmentDoctorName',
    //   'chargeOrRefundTime',
    //   'state',
    // ]
    // exportXLSXList = exportXLSXList?.map((item) => {
    //   return {
    //     ...item,
    //     paymentId: item?.paymentId ? item?.paymentId : '-',
    //     patientName: item?.patientName ? item?.patientName : '-',
    //     patientId: item?.patientId > -1 ? item?.patientId : '-',
    //     patientPhone: item?.patientPhone ? item?.patientPhone : '-',
    //     insuranceCode:
    //       item?.insuranceCode == 'ZIFEI' || !item?.insuranceCode
    //         ? '自费'
    //         : '智慧医保',
    //     billingCategory: item?.billingCategory
    //       ? BillingCategoryName(item?.billingCategory)
    //       : '-',
    //     drugName: item?.drugName ? item?.drugName : '-',
    //     retailPrice:
    //       Number(item?.retailPrice) > 0 ? item?.retailPrice.toFixed(2) : '-',

    //     drugCount: Number(item?.drugCount) > 0 ? item?.drugCount : '-',
    //     drugAmount:
    //       Number(item?.drugAmount) > 0 ? item?.drugAmount.toFixed(2) : '-',

    //     treatmentDoctorName: item?.treatmentDoctorName
    //       ? item?.treatmentDoctorName
    //       : '-',
    //     chargeOrRefundTime: item?.chargeOrRefundTime
    //       ? moment(item?.chargeOrRefundTime)?.format(DateTimeFormatSimple)
    //       : '-',
    //     state: item?.state ? getTransactionQueryName(Number(item?.state)) : '-',
    //   }
    // })
    // const data = exportXLSXList?.slice(0, 500)
    // const value =
    //   exportXLSXList?.length >= 500
    //     ? data?.map
    //     : exportXLSXList?.map((v: any) => filterVal?.map((j: any) => v[j]))
    // import('../../../ExportXLSX/Export2Excel').then((excel) => {
    //   excel.export_json_to_excel({
    //     header: theader,
    //     data: value,
    //     filename: '交易明细查询',
    //     autoWidth: true,
    //     bookType: 'xlsx',
    //   })
    //   setIds([])
    //   setParams({
    //     ...params,
    //     current: 1,
    //   })
    //   exportXLSXList = []
    // })
    dispatch(
      getTransactionDetailQueryExport({
        ...params,
        releasingTime: releasingTimeFlag ? '99' : undefined,
        pageName: location.pathname,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '交易明细查询.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .finally(() => {
        dispatch(setExportLoading(false))
      })
  }

  // useEffect(() => {
  //   if (exportXLSXList?.length >= 500) {
  //     message.info('最多可导出500条')
  //   }
  // }, [exportXLSXList])

  const onResize = () => {
    const table = document.getElementById('tableHeight')
    if (table) {
      const height = table.offsetHeight - 60 - 80 - 20
      setScrollHeight(height)
    } else {
      return '100%'
    }
  }

  return (
    <Col
      className={styles.jymxcxContainer}
      style={{
        backgroundColor: theme.pn,
        marginTop: flag ? 0 : '10px',
        padding: flag ? 0 : '20px 15px',
      }}
    >
      <Query
        loading={pageLoading}
        onValueChange={(v: any) => {
          setParams({
            ...params,
            ...v,
            registrationTimeHead: v?.timeHead
              ? moment(v?.timeHead).format(DateTimeFormatSimpleOnlyOne)
              : moment(timeHead).format(DateTimeFormatSimpleOnlyOne),
            registrationTimeTail: v?.timeTail
              ? moment(v?.timeTail).format(DateTimeFormatSimpleOnlyOne)
              : moment(timeTail).format(DateTimeFormatSimpleOnlyOne),
            timeHead: undefined,
            timeTail: undefined,
          })
        }}
        selectedTab={selectedTab}
        alertMessage={() => {
          setReleasingTime(true)
        }}
        filterColumn={columnQueryFilterList} //筛选列
        filterSelectList={filterSelectList}
        // 筛选列变化时的数据
        submitPageList={(v: any) => {
          setPageLoading(true)
          submitPageList(v)
          setAllColumnList(v)
        }}
      />
      <div
        style={{
          width: '100%',
          height: '100%',
        }}
      >
        <SimpleAgGrid
          page={page}
          column={(TransactionDetailAGColumns(
            page?.size * (page?.current - 1),
            columnQueryFilterList,
            CKHZSJHData,
            CKHZSFZHData
          ))?.filter((item: any) => filterSelectList?.includes(item.field))}
          isLoading={pageLoading}
          pagination={true}
          pageKey={'transactionQueryDetail'}
          rowSelection="multiple"
          rowHeight={hisVersion == 1 ? 71 : 41}
          rowKey={(m: any) => m?.paymenItemtId + '_' + m?.fyid}
          pinnedBottomRowData={[{
            drugCount: totalData?.drugCountAll || 0,
            drugAmount: totalData?.drugAmountAll?.toFixed(2) || '',
            // 剩余没有合计行的列展示为空
          }]}
          suppressRowClickSelection={true}
          // 配置底部行样式
          getRowStyle={(params) => {
            if (params.node.rowPinned) {
              return {
                fontWeight: 'normal',
                backgroundColor: '#D9F2FF',
              };
            }
            return {}; // 将返回 null 改为返回空对象，避免类型不匹配问题
          }}
          onChangePage={(current, size) => {
            setParams({
              ...params,
              current,
              size,
            })
            setPage({
              ...page,
              current,
              size,
            })
          }}
          onColumnResized={(v) => {
            return
          }}
          onColumnMoved={(v) => {
            const sortList = getSortColumnList(allColumnList, v);
            submitPageList(sortList)
            setAllColumnList(sortList)
          }}
        />
        <div
          style={{
            position: 'absolute',
            bottom: '20px',
            left: '20px',
            lineHeight: (hisVersion != 1 && '60px') as any
          }}
        >
          共{page?.total} 条数据，总数量：{allTotalData?.totalCount || '0'}，总金额：{allTotalData?.totalAmount || '0.00'}
        </div>
      </div>
    </Col>
  )
}

export const TransactionDetailQuerys = forwardRef(TransactionDetailQuery)
